import { render } from "./LegalBlock.vue?vue&type=template&id=42929813"
import script from "./LegalBlock.vue?vue&type=script&lang=js"
export * from "./LegalBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__